import React, { memo } from 'react';

const PaperclipIcon = ({ color = '#9F9DA3', className }: { color?: string, className?: string }) => {
  return (
    <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        d="M21.3332 11.515L11.7603 21.0879C10.5876 22.2607 8.99696 22.9195 7.33844 22.9195C5.67991 22.9195 4.08932 22.2607 2.91656 21.0879C1.74381 19.9152 1.08496 18.3246 1.08496 16.6661C1.08496 15.0075 1.74381 13.4169 2.91656 12.2442L12.4895 2.67126C13.2713 1.88943 14.3317 1.4502 15.4374 1.4502C16.5431 1.4502 17.6035 1.88943 18.3853 2.67126C19.1671 3.4531 19.6064 4.5135 19.6064 5.61918C19.6064 6.72486 19.1671 7.78526 18.3853 8.5671L8.80198 18.14C8.41106 18.5309 7.88086 18.7505 7.32802 18.7505C6.77518 18.7505 6.24498 18.5309 5.85406 18.14C5.46314 17.7491 5.24353 17.2189 5.24353 16.6661C5.24353 16.1132 5.46314 15.583 5.85406 15.1921L14.6978 6.35876"
        stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
};

export default memo(PaperclipIcon);

